import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
export interface UserData {
  name: string;
  email: string;
  id: string;
  loginType: string;
}

@Injectable({
  providedIn: 'root',
})
export class UserService {
  public user$: BehaviorSubject<UserData | null> = new BehaviorSubject<UserData | null>(null);

  private _userData: UserData | null = null;

  constructor() {}

  //------------------------------------------------------------------------------------------------
  // @ Accessors
  //------------------------------------------------------------------------------------------------

  get userData(): UserData | null {
    return this._userData;
  }

  set userData(userData: UserData | null) {
    this._userData = userData;
    this.user$.next(userData);
  }

  get email(): string {
    return this._userData?.email || '';
  }

  get name(): string {
    return this._userData?.name || '';
  }

  get id(): string {
    return this._userData?.id || '';
  }

  get loginType(): string {
    return this._userData?.loginType || '';
  }
}
